export const ExternalCodePartial = `
... on SearchResultGraphCode {
    path
    repository {
        name
    }
}
`;
